import React from "react";
import MyContext from "./MyContext";

const MyProvider = (props) => {
  const [tabValue, setTabValue] = React.useState(null);
  const [carModel, setCarModel] = React.useState(null);
  return (
    <MyContext.Provider
      value={{ tabValue, setTabValue, carModel, setCarModel }}
    >
      {props.children}
    </MyContext.Provider>
  );
};

export default MyProvider;
